import React from "react";

import { MOBILE_BREAKPOINT } from "../../constants";
import { MODES } from "../../urlParams";
import Panel from "../Panel";
import Button from "../Button";
import WhatModal from "../WhatModal";
import styled from "styled-components";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 270px;
  grid-template-rows: repeat(3, 44px);
  align-items: stretch;
  justify-items: stretch;
  gap: 1rem;
  --pattern-color: rgba(0, 0, 0, 0.05);

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    grid-template-rows: repeat(3, 40px);
    gap: 0.5rem;
    /* align-items: center; */
    /* justify-content: center; */
    margin-top: 1.5rem;
  }
`;

const SpeedrunButton = styled(Button)`
  --pattern-size: 2px;
  background-image: repeating-linear-gradient(
    45deg,
    var(--pattern-color),
    var(--pattern-color) var(--pattern-size),
    transparent var(--pattern-size),
    transparent 9px
  );
`;

const CreativeButton = styled(Button)`
  /* background-color: var(--color-orange-50); */
  --pattern-size: 2px;
  --pattern-color: rgba(0, 0, 0, 0.05);
  background-image:
    radial-gradient(
      var(--pattern-color) var(--pattern-size),
      transparent var(--pattern-size)
    ),
    radial-gradient(
      var(--pattern-color) var(--pattern-size),
      transparent var(--pattern-size)
    );
  background-size: 20px 20px;
  background-position:
    0 0,
    10px 10px;
`;

const SmallerButton = styled(Button)`
  background-color: var(--color-orange-100);
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 130px);
  align-items: stretch;
  justify-items: stretch;
  justify-content: space-between;
`;

// Creative button opens the marc picker WITHOUT switching to creative
// mode — picking a marc from the modal is what transitions us. This
// avoids the brief no-marc-selected window in creative that used to
// remount the landing trace at full opacity behind the picker (read as
// an afterimage on top of the modal). It also makes dismissing the
// picker a non-event: you were always in landing, you stay in landing.
function LandingUIPanel({ setMode, onCreativeClick }) {
  const [whatOpen, setWhatOpen] = React.useState(false);
  return (
    <Panel
      style={{
        display: "grid",
        placeItems: "center",
      }}
    >
      <Wrapper>
        <CreativeButton size="large" onClick={onCreativeClick}>
          Creative Mode
        </CreativeButton>
        <SpeedrunButton size="large" onClick={() => setMode(MODES.SPEEDRUN)}>
          Speedrun Mode
        </SpeedrunButton>
        <Row>
          <SmallerButton
            size="large"
            onClick={() => {
              window.location.href = "/gallery";
            }}
          >
            Egg Gallery
          </SmallerButton>
          <SmallerButton size="large" onClick={() => setWhatOpen(true)}>
            Manifesto
          </SmallerButton>
        </Row>
      </Wrapper>
      <WhatModal open={whatOpen} onOpenChange={setWhatOpen} />
    </Panel>
  );
}

export default LandingUIPanel;
